import React, { useState } from "react";
import {
  Card,
  Link as MuiLink,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { OrderPage } from "./OrderPage";

const formatDate = (d) => {
  if (!d) return "";
  const date = new Date(d);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-GB");
};

export const OrdersList = (props) => {
  const theme = useTheme();
  const isCompact = useMediaQuery(theme.breakpoints.down("md"));
  const [selectedItem, setSelectedItem] = useState(null);

  const items = props.orders?.result || [];

  if (props.showItem) {
    return (
      <OrderPage
        onBack={() => props.setShowItem(false)}
        item={selectedItem}
      />
    );
  }

  const handleOpen = (it) => {
    setSelectedItem(it);
    props.setShowItem(true);
  };

  const columns = isCompact
    ? [
        { key: "no", label: "No" },
        { key: "postingDate", label: "Date" },
        { key: "vehicleRegistrationNumber", label: "Reg" },
        { key: "location", label: "Location" },
      ]
    : [
        { key: "no", label: "No" },
        { key: "postingDate", label: "Date" },
        { key: "vehicleRegistrationNumber", label: "Reg" },
        { key: "location", label: "Location" },
        { key: "locationCode", label: "Warehouse" },
        { key: "fitterName", label: "Fitter" },
      ];

  return (
    <Card
      sx={{
        overflow: "hidden",
        border: (t) => `1px solid ${t.palette.divider}`,
        boxShadow: "none",
      }}
    >
      <TableContainer>
        <Table size="medium" stickyHeader>
          <TableHead>
            <TableRow sx={{ bgcolor: "background.default" }}>
              {columns.map((c) => (
                <TableCell
                  key={c.key}
                  sx={{
                    fontWeight: 700,
                    textTransform: "uppercase",
                    fontSize: 12,
                    letterSpacing: 0.5,
                    bgcolor: "background.default",
                  }}
                >
                  {c.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((it, idx) => {
              const row = {
                no: it.orderNumber,
                postingDate: it.postingDate,
                vehicleRegistrationNumber: it.vehicleRegistrationNumber,
                location: it.location,
                locationCode: it.locationCode,
                fitterName: it.fitterName,
                // Full item passed downstream — keep original keys.
                _raw: it,
              };
              return (
                <TableRow
                  key={`${row.no}-${idx}`}
                  hover
                  onClick={() => handleOpen({
                    no: row.no,
                    documentNumber: it.id,
                    documentType: it.documentType,
                    selltoCustomerNo: it.sellToCustomerNumber,
                    selltoCustomerName: it.sellToCustomerName,
                    postingDate: it.postingDate,
                    vehicleRegistrationNumber: it.vehicleRegistrationNumber,
                    location: it.location,
                    locationCode: it.locationCode,
                    fitterName: it.fitterName,
                    fitterNo: it.fitterNumber,
                    serviceType: it.serviceType,
                    mileage: it.mileage,
                    docketNo: it.docketNumber,
                    reTorque: it.reTorque,
                    salesPersonCode: it.salesPersonCode,
                    tyreCheck: it.tyreCheck,
                    postedSalesInvoiceLines: it.postedSalesInvoiceLines,
                  })}
                  sx={{
                    cursor: "pointer",
                    "&:last-of-type td": { borderBottom: 0 },
                  }}
                >
                  <TableCell>
                    <MuiLink
                      component="button"
                      type="button"
                      underline="hover"
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        color: "primary.main",
                        fontWeight: 600,
                        fontSize: isCompact ? 13 : 14,
                      }}
                    >
                      {row.no}
                    </MuiLink>
                  </TableCell>
                  <TableCell sx={{ fontSize: isCompact ? 13 : 14 }}>
                    {formatDate(row.postingDate)}
                  </TableCell>
                  <TableCell sx={{ fontSize: isCompact ? 13 : 14 }}>
                    {row.vehicleRegistrationNumber || "—"}
                  </TableCell>
                  <TableCell sx={{ fontSize: isCompact ? 13 : 14 }}>
                    {row.location || "—"}
                  </TableCell>
                  {!isCompact && <TableCell>{row.locationCode || "—"}</TableCell>}
                  {!isCompact && <TableCell>{row.fitterName || "—"}</TableCell>}
                </TableRow>
              );
            })}
            {items.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  align="center"
                  sx={{ py: 6, color: "text.secondary" }}
                >
                  <Typography variant="body2">No orders to show</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};
